export class TierGeschlecht {
    geschlecht_id: number;
    bezeichnung: string;
    anzahl: number; // nur für Filter
}
